import { login, logout } from '../../../services/AuthService';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const FEDERATED_LOGIN = 'FEDERATED_LOGIN';
export const CHANGE_PASSWORD_CHALLENGE = 'CHANGE_PASSWORD_CHALLENGE';
export const USER_AVAILABLE = 'USER_AVAILABLE';

const loginAction = (username, password, errorMessageHandler) => ({
    type: USER_LOGIN,
    payload: login(username, password, errorMessageHandler),
});

const logoutAction = () => ({
    type: USER_LOGOUT,
    payload: logout(),
});

const federatedLoginAction = user => ({
    type: FEDERATED_LOGIN,
    payload: user,
});

const changePasswordChallenge = () => ({
    type: CHANGE_PASSWORD_CHALLENGE,
});

const changePasswordChallengeFullfilled = () => ({
    type: `${CHANGE_PASSWORD_CHALLENGE}_FULFILLED`,
});

const userAvailable = user => ({
    type: USER_AVAILABLE,
    payload: user,
});

export {
    logoutAction as logout,
    loginAction as login,
    federatedLoginAction as federatedLogin,
    changePasswordChallenge,
    changePasswordChallengeFullfilled,
    userAvailable,
};
